/* ============================================================
   FEMBE VARIANT CARDS  ·  <fembe-variant-cards>
   Conversion-Karten-Picker für Be Yours v9.
   - Lebt INNERHALB von <variant-selects>; echte Radios steuern
     die native Variantenlogik (Preis/Galerie/URL).
   - connectedCallback re-initialisiert nach jedem HTML-Swap
     von product-info.js (kein Listener-Leak).
   - Abo-Preis-Sync über window.cvState + Event 'cv:type-changed'.
   ============================================================ */
(function () {
  'use strict';
  if (window.customElements && customElements.get('fembe-variant-cards')) return;

  function eur(cents) {
    if (!isFinite(cents)) cents = 0;
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2).replace('.', ',') + ' €';
    }
  }

  class FembeVariantCards extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.free = parseInt(this.dataset.freeShipping, 10) || 0;
      try {
        this.vData = JSON.parse(this.querySelector('[data-fembe-vcard-data]').textContent);
      } catch (e) {
        this.vData = {};
      }
      this.summaryEl = this.querySelector('[data-fembe-vsummary]');

      this._render = this._render.bind(this);
      this.addEventListener('change', this._render);
      document.addEventListener('cv:type-changed', this._render);

      this._autoSelectBest();
      this._render();
      // Nach dem subscription-widget (setzt cvState) nochmal nachziehen.
      this._settleTimer = setTimeout(this._render, 300);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this._render);
      document.removeEventListener('cv:type-changed', this._render);
      clearTimeout(this._settleTimer);
    }

    /* ── Abo-Rabatt aus geteiltem State ── */
    _discount() {
      var st = window.cvState;
      var off = { active: false, type: 'percentage', value: 0 };
      if (!st || st.type !== 'subscription') return off;
      /* Nur anwenden, wenn cvState zu DIESEM Produkt gehört (nicht zu einem
         Quick-View eines anderen Produkts auf derselben Seite). */
      if (st.variantIds && st.variantIds.length) {
        var mine = Object.keys(this.vData);
        var overlap = mine.some(function (id) { return st.variantIds.indexOf(id) !== -1; });
        if (!overlap) return off;
      }
      return { active: true, type: st.discountType || 'percentage', value: Number(st.discountValue) || 0 };
    }
    _effectivePrice(base) {
      var d = this._discount();
      if (!d.active || !d.value) return base;
      /* d.value wie Shopify price_adjustment: percentage=Prozent, fixed_amount/price=Cents.
         MUSS mit _aboPrice in component-subscription-widget.js übereinstimmen. */
      if (d.type === 'percentage') return Math.round(base * (1 - d.value / 100));
      if (d.type === 'fixed_amount') return Math.max(0, base - d.value);
      if (d.type === 'price') return d.value;
      return base;
    }
    _perDayCents(price, d) {
      var r = Number(d.reichweite) || 0, it = Number(d.items) || 0, dose = Number(d.tagesdosis) || 1;
      if (dose <= 0) dose = 1;
      if (r > 0) return price / r;
      if (it > 0) return (price * dose) / it;
      return price / 30;
    }
    _selectedInput() {
      return this.querySelector('.fembe-vcard__input:checked');
    }

    /* ── Conversion: beste/größte Packung vorwählen, wenn keine ?variant ──
       Nur auf der Haupt-PDP – nicht in Quick-View/Modal/Featured
       (data-update-url="false"), um dort einen unnötigen Fetch/Flash zu vermeiden.
       Für flicker-freie Vorauswahl: größte Variante als Standard-Variante im
       Shopify-Admin setzen (dann ist dieser Schritt ein No-Op). */
    _autoSelectBest() {
      var pi = this.closest('product-info');
      if (pi && pi.dataset.updateUrl === 'false') return;
      try { if (new URLSearchParams(window.location.search).get('variant')) return; } catch (e) { return; }
      var best = this.querySelector('[data-is-best="true"] .fembe-vcard__input');
      if (best && !best.checked && !best.disabled) {
        best.checked = true;
        best.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    _render() {
      if (!this.isConnected) return; /* nach HTML-Swap nicht auf altem Knoten rendern */
      var self = this;

      this.querySelectorAll('[data-vcard]').forEach(function (card) {
        var d = self.vData[card.dataset.variantId];
        if (!d) return;
        var input = card.querySelector('.fembe-vcard__input');
        var isSel = !!(input && input.checked);

        /* Badge: Ausgewählt > Beste Wahl > Beliebt > versteckt */
        var badge = card.querySelector('[data-vcard-badge]');
        if (badge) {
          badge.classList.remove(
            'fembe-vcard__badge--selected', 'fembe-vcard__badge--best',
            'fembe-vcard__badge--popular', 'fembe-vcard__badge--hidden'
          );
          card.classList.toggle('fembe-vcard--selected', isSel);
          if (isSel) { badge.classList.add('fembe-vcard__badge--selected'); badge.textContent = 'Ausgewählt'; }
          else if (card.dataset.isBest === 'true') { badge.classList.add('fembe-vcard__badge--best'); badge.textContent = 'Beste Wahl'; }
          else if (card.dataset.isPopular === 'true') { badge.classList.add('fembe-vcard__badge--popular'); badge.textContent = 'Beliebt'; }
          else { badge.classList.add('fembe-vcard__badge--hidden'); badge.textContent = ''; }
        }

        /* Preis pro Tag / Monat (reagiert auf Abo-Rabatt) */
        var price = self._effectivePrice(d.price);
        var perEl = card.querySelector('[data-vcard-per]');
        if (perEl && perEl.dataset.mode !== 'none') {
          var r = Number(d.reichweite) || 0;
          if (perEl.dataset.mode === 'month' && r >= 30) {
            perEl.innerHTML = eur(Math.round(price * 30 / r)) + '<span class="fembe-vcard__per-suffix">&nbsp;/&nbsp;Monat</span>';
          } else if (r > 0) {
            perEl.innerHTML = eur(Math.round(price / r)) + '<span class="fembe-vcard__per-suffix">&nbsp;/&nbsp;Tag</span>';
          }
        }

        /* Gratis-Versand abhängig vom effektiven Preis */
        var ship = card.querySelector('[data-vcard-shipping]');
        if (ship) ship.classList.toggle('fembe-vcard__shipping--hidden', !(price >= self.free));
      });

      /* Summary-Bar (ausgewählte Variante) */
      if (this.summaryEl) {
        var sel = this._selectedInput();
        var d = sel ? this.vData[sel.dataset.variantId] : null;
        var perEl = this.summaryEl.querySelector('[data-vsummary-perday]');
        var reachEl = this.summaryEl.querySelector('[data-vsummary-reach]');
        if (d && Number(d.reichweite) > 0) {
          var price = this._effectivePrice(d.price);
          if (perEl) perEl.textContent = eur(Math.round(this._perDayCents(price, d)));
          if (reachEl) reachEl.textContent = Number(d.reichweite) + ' Tage';
          this.summaryEl.style.display = '';
        } else {
          this.summaryEl.style.display = 'none';
        }
      }
    }
  }

  customElements.define('fembe-variant-cards', FembeVariantCards);
})();
